export default __webpack_public_path__ + "static/media/IconDesc_SpikedRebar.256.1becd721.png";